export const keyMap = 'AIzaSyAH1hgI_INkB5xgjCvdYxorP4PgV1Oqiqo';

export default {
  keyMap,
};
